import {Component, EventEmitter, OnInit, Output, NgZone, Input} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {iInpost, iInpostPoint} from "../../model/CartModel";
import {CartService} from "../../services/cart.service";
import {ScriptLoaderService} from "../../services/scripts.service";

@ComponentAsElement('v-cart-inpost-element')
@Component({
  selector: 'v-cart-inpost',
  templateUrl: './cart-inpost.component.html'
})
export class CartInpostComponent implements OnInit {
  @Input() widget: boolean;
  @Input() error: boolean;
  @Input('api-key') apiKey: string;
  @Output() defineInpost: EventEmitter<null|iInpost> = new EventEmitter();
  showInpostMap;
  selectedInpost: iInpost = {
    apartment: '',
    building: '',
    name: '',
    postCode: '',
    street: '',
    town: ''
  };
  showSelectedInpost = false;
  inpostMap = false;

  constructor(
    private cartService: CartService,
    private ngZone: NgZone,
    private scriptLoaderService: ScriptLoaderService)
  { }

  ngOnInit() {
    this.scriptLoaderService.load('geowidget');
    this.cartService.selectedSettings.subscribe(_settings => {
      const settings = _settings;

      if(settings.selectedInPostAddress) {
        this.selectedInpost = settings.selectedInPostAddress;
        this.defineInpost.emit(this.selectedInpost);
        this.ngZone.run(() => {
          this.showInpostMap = false;
          this.showSelectedInpost = true;
        });
      }
      else {
        this.ngZone.run(() => {
          this.showInpostMap = true;
          this.showSelectedInpost = false;
        });
      }
    });
  }

  ngOnChanges() {
    if(this.widget) {
      this.initInpost();
    }
  }

  private selectInpost(_point: iInpostPoint) {
    const point = _point;

    this.selectedInpost.apartment = point.address_details.flat_number;
    this.selectedInpost.building = point.address_details.building_number ? point.address_details.building_number : point.name;
    this.selectedInpost.name = point.name;
    this.selectedInpost.postCode = point.address_details.post_code;
    this.selectedInpost.street = point.address_details.street;
    this.selectedInpost.town = point.address_details.city;
    this.cartService.changeDelivery('inpost', this.selectedInpost).subscribe(() => {
      this.defineInpost.emit(this.selectedInpost);
    });
  }

  public initInpost() {
    window['easyPackAsyncInit'] = () => {
      window['easyPack'].init({
        points: {
          types: ['parcel_locker']
        },
        mapType: 'google',
        searchType: 'google',
        map: {
          googleKey: this.apiKey
        }
      });
      this.inpostMap = window['easyPack'].mapWidget('easypack-map', (point: iInpostPoint) => {
        this.selectInpost(point);
      });
    }
  }

  newInpost() {
    this.cartService.clearMethods();
    Object.keys(this.selectedInpost).forEach(key => {
      this.selectedInpost[key] = ''
    });
    this.defineInpost.emit(null);
    this.showSelectedInpost = false;
    this.showInpostMap = true;
    if(!this.widget) {
      this.initInpost();
      this.widget = true;
    }
  }
}
